import styled from 'styled-components';

export const DotGridMask = styled.div`
  position: absolute;
  inset: 0;
  mask-image: radial-gradient(white, white 1px, transparent 1px, transparent);
  mask-size: 6px 6px;
`;
